import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Button, Form, Segment, Table } from "semantic-ui-react";

class CreateItem extends Component {
  constructor(props) {
    super(props);

    this.editItemIndex = 0;

    this.state = {
      isEdit: false, // 預設都是新增

      find_Edit: "",
      replaceWith_Edit: "",

      Name: "",
      find: "",

      replaceWith: "",

      showAdditem: false,

      showSaveName: false,

      isCaseSensitivity: false,

      isEditItem: false,

      items: [],
    };
    this.setFindBlue = this.setFindBlue.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  async closeDialog() {
    this.props.showMultipleFindReplace(false);
  }

  async componentDidMount() {
    await this.setState({ items: this.props.items });

    console.log(this.state.items);

    if (this.props.isCreateNewItem === false) {
      // await this.setState({ value: this.props.project.statusValue });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  async setFindBlue(result) {
    // this.props.showFindPositionAndAlign(result);
  }

  render() {
    const { items } = this.state;

    return (
      <div
        className="AddItem"
        title="AddItem"
        style={{ width: "450px", height: "490px" }}
        ref={(ref) => (this.positionAligndlg = ref)}
      >
        <div>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Find</Table.HeaderCell>
                <Table.HeaderCell colSpan="2">Replace with</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {items.length === 0
                ? null
                : items.map((object, i) => {
                    return (
                      <Table.Row key={i}>
                        <Table.Cell>
                          <a
                            style={{
                              textDecoration: "underline",
                              color: "blue",
                            }}
                            onClick={async () => {
                              this.editItemIndex = i;

                              this.setState({
                                isEditItem: true,
                              }); 

                              this.setState({
                                find_Edit: object.find,
                              });

                              this.setState({
                                replaceWith_Edit: object.replaceWith,
                              });

                              this.setState({
                                Find: object.find,
                              });
                              this.setState({
                                replaceWith: object.replaceWith,
                              });
                            }}
                          >
                            {object.find}
                          </a>
                          {this.state.isEditItem === true &&
                          this.editItemIndex == i ? (
                            <Form.Field>
                              <input
                                value={this.state.find_Edit}
                                placeholder="Find"
                                onChange={(e) => {
                                  this.setState({ find_Edit: e.target.value });
                                }}
                              />
                            </Form.Field>
                          ) : null}
                        </Table.Cell>
                        <Table.Cell>
                          {object.replaceWith}

                          {this.state.isEditItem === true &&
                          this.editItemIndex == i ? (
                            <Form.Field>
                              <input
                                value={this.state.replaceWith_Edit}
                                placeholder="Replace With "
                                onChange={(e) => {
                                  this.setState({
                                    replaceWith_Edit: e.target.value,
                                  });
                                }}
                              />
                            </Form.Field>
                          ) : null}
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            primary
                            size="mini"
                            onClick={async () => {
                              var array = [...this.state.items]; // make a separate copy of the array
                              var index = i;
                              if (index !== -1) {
                                array.splice(index, 1);
                                await this.setState({
                                  items: array,
                                });

                                // 編輯完後 直接上傳save
                                await this.props.uploadItem(this.state.items);
                              }
                            }}
                          >
                            Remove
                          </Button>

                          {this.state.isEditItem === true &&
                          this.editItemIndex == i ? (
                            <div>
                              <Button
                              primary
                              size="mini"
                              onClick={async () => {
                                if (this.state.find_Edit !== "") {
                                  var array = [...this.state.items]; // make a separate copy of the array
                                  array[i] = {
                                    find: this.state.find_Edit,
                                    replaceWith: this.state.replaceWith_Edit,
                                  };
                                  await this.setState({
                                    items: array,
                                  });

                                  // 編輯完後 直接上傳save
                                  await this.props.uploadItem(this.state.items);

                                  await this.setState({
                                    isEditItem: false,
                                  });
                                }
                              }}
                            >
                              Save
                            </Button>
                            <Button
                               color="gery"
                              size="mini"
                              onClick={async () => {
                                await this.setState({
                                  isEditItem: false,
                                });
                              }}
                            >
                              Cancel
                            </Button>
                            </div>
                          ) : null}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
            </Table.Body>
          </Table>
          <div>
            <Button
              size="mini"
              onClick={() => {
                this.isEdit = false;
                this.setState({ showAdditem: !this.state.showAdditem });

                this.setState({
                  Find: "",
                });
                this.setState({
                  replaceWith: "",
                });
              }}
            >
              Add Item
            </Button>
            <Button
              size="mini"
              onClick={async () => {
                if (this.props.isCreateNewItem === true) {
                  if (this.state.Name !== "") {
                    // 新增一個新的
                    this.props.addNewMultipleFindReplace({
                      Name: this.state.Name,
                      items: this.state.items,
                    });
                  } else if (this.state.Name === "") {
                    ////// 新的
                    // 要新增Name
                    await this.setState({ showSaveName: true });
                    await this.setState({ showAdditem: false });
                  }
                } else {
                  ////// 編輯的
                  // 關掉編輯室窗
                  await this.setState({ showAdditem: false });

                  // 編輯完後 直接上傳save
                  this.props.uploadItem(this.state.items);
                }
              }}
            >
              Save Changes
            </Button>
          </div>

          {this.state.showSaveName === true ? (
            <Segment>
              <Form>
                <Form.Field>
                  <label>Name:</label>
                  <input
                    placeholder="Find"
                    onChange={(e) => {
                      this.setState({ Name: e.target.value });
                    }}
                  />
                </Form.Field>
                <Button
                  type="submit"
                  onClick={() => {
                    // this.setState({items,[...this.state.items, 'Carl']});

                    if (this.state.Name !== "") {
                      this.props.addNewMultipleFindReplace({
                        Name: this.state.Name,
                        items: this.state.items,
                      });
                    } else if (this.state.Name === "") {
                      alert("Need Name");
                    }
                  }}
                >
                  Save
                </Button>
                <Button type="submit">Cancel</Button>
              </Form>
            </Segment>
          ) : null}

          {this.state.showAdditem === true ? (
            <Segment>
              <Form>
                <Form.Field>
                  <label>Find:</label>
                  <input
                    placeholder="Find"
                    onChange={(e) => {
                      this.setState({ find: e.target.value });
                    }}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Replace with:</label>
                  <input
                    placeholder="Replace"
                    onChange={(e) => {
                      this.setState({ replaceWith: e.target.value });
                    }}
                  />
                </Form.Field>
                <Button
                  type="submit"
                  onClick={async () => {
                    // 上傳 Find
                    if (this.state.find !== "") {
                      await this.setState({
                        items: [
                          ...this.state.items,
                          {
                            find: this.state.find,
                            replaceWith: this.state.replaceWith,
                          },
                        ],
                      });

                      if (this.props.isCreateNewItem === false) {
                        // 編輯完後 直接上傳save
                        await this.props.uploadItem(this.state.items);
                      }

                      await this.setState({ find: "" });
                      await this.setState({ replaceWith: "" });
                      await this.setState({ showAdditem: false });
                    }
                  }}
                >
                  Add
                </Button>
                <Button type="submit">Cancel</Button>
              </Form>
            </Segment>
          ) : null}

          <div>
            <div
              style={{
                width: "200px",
              }}
            >
              <Button
                onClick={async() => {
                  // this.state.items
                  for (let i = 0; i < items.length; i++) {
                    const currentItem = items[i];
                   await this.props.handleReplace(1, {
                      findString: currentItem.find,
                      wantReplaceString: currentItem.replaceWith,
                      isSubtitle: true,
                      isMemo: false,
                      isCaseSensitivity: this.state.isCaseSensitivity,
                      isSource: false,
                    });
                  }
                }}
              >
                Replace
              </Button>
              <div className="form-check">
                <input
                  checked={this.state.isCaseSensitivity}
                  onClick={() =>
                    this.setState({
                      isCaseSensitivity: !this.state.isCaseSensitivity,
                    })
                  }
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="defaultCheck1"
                />
                <label className="form-check-label" htmlFor="defaultCheck1">
                  Case Sensitive
                </label>
              </div>
            </div>

            <Button
              primary
              size="mini"
              onClick={() => this.props.setShowCreate()}
            >
              Back to List
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

CreateItem.propTypes = {};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  editTable: state.editTable,
});

export default connect(mapStateToProps, {})(withRouter(CreateItem));



// WEBPACK FOOTER //
// ./src/components/multipleFind/MultipleFindReplace/CreateItem.js